<template>
  <v-container>

    <v-flex>
      <!--img src="../assets/logo-rounded-200.png"><br -->
      <img src="../../../static/images/smartkidsmarket-logo.svg" style="height:100px"/>
      <h2>SmartKidsMarket</h2>
      <br />
      <h2>Returning to Parent Portal...</h2>
      <div class="error--text">
        {{errMessage}}
      </div>
    </v-flex>

  </v-container>

</template>

<script>
import firebase from 'firebase/app'
import {mapState} from 'vuex'

export default {
  name: 'ReturnToParentPortal',
  data () {
    return {
      errMessage: null
    }
  },
  computed: {
    ...mapState({
      parentToken: (state) => state.parent.parentToken
    }),
  },
  mounted: async function () {
    // Check for the
    if (!this.parentToken) {
      console.error('Error: Cannot go back to parent portal, no parent token.')
      this.errMessage = "Error: Cannot return to parent portal. Login again."
    } else {

      // Login as the parent and return to the parent portal
      // Now login with the token
      console.log("DEBUG: signing with custom PPortal token")
      const rc = await firebase.auth().signInWithCustomToken(this.parentToken)
      console.log("RTP: rc:"+rc)

      // Go to the Parent's main page
      this.$router.push({name: 'ParentPortal'})
    }

  },
}
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */

h2 {
  text-align: center;
}

.link {
  text-decoration: underline;

}

</style>
